import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/global.scss'
import i18n from './i18n'

Vue.config.productionTip = false

// 使用 Element UI
Vue.use(ElementUI)

// 设置 Element UI 主题色
document.documentElement.style.setProperty('--el-color-primary', '#ff6b00')

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
